import Swiper from 'swiper/bundle';

var GeneralHero = function () {
    const sliders = document.querySelectorAll('.hero__swiper');

    if (!sliders.length) return;

    sliders.forEach(slider => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.hero__swiper-wrapper');
        if (!swiperWrapper) return;

        // get the current slide for when updating the counter
        const currentSlide = slider.querySelector('.hero__current');

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            pagination: false,
            navigation: {
                nextEl: slider.querySelector('.hero__nav--next'),
                prevEl: slider.querySelector('.hero__nav--prev'),
            },
            speed: 300,
            autoplay: false,
            on: {
                init(swiper) {
                    if (currentSlide) {
                        currentSlide.textContent = swiper.realIndex + 1;
                    }
                },
                slideChange(swiper) {
                    if (currentSlide) {
                        currentSlide.textContent = swiper.realIndex + 1;
                    }
                },
            },
        });
    });
};

export default GeneralHero;
